export default __webpack_public_path__ + "d1bb13ce1a593d82e4c0d821dc7f1b41.svg";